module.exports = __webpack_public_path__ + "static/media/bg4.826c2c08.jpeg";